// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3YlaE","header":"MessagesList_header__1d3u7","chat":"MessagesList_chat__2DF5C"};